module.exports = "/_next/static/images/openPositions-417c1afb83b3963eea134d29680d49eb.webp";